export class Aba {
    constructor({
      id = null,
      nome = null,
      nomeDeExibicao = null,
      permissoes = Array(),
    }) {
      this.id = id;
      this.nome = nome;
      this.nomeDeExibicao = nomeDeExibicao;
      this.permissoes = permissoes;
    }
    static Build() {
      return new Aba({
        id: null,
        nome: null,
        nomeDeExibicao: null,
        permissoes: Array(),
      });
    }
    format() {
      this.permissoes = this.permissoes.map((p) => p.id);
      return this;
    }
  }
  